import React, { useState, useEffect } from "react";

import {
  Container,
  Stack,
  FormControlLabel,
  Checkbox,
  Button,
  Drawer,
  Box,
} from "@mui/material";
import {
  getOptions,
  ScenarioUrl,
  empty_uuid,
  ftchPlus,
} from "./Account_urls.jsx";
import { InputAccountsTypesNames } from "../Components/Inputs/Account_TypesNames";
import { errorCheckForm, errorClear, errorJsonHasErrors, errorSet } from "../Components/Inputs/Input_Fns";
import { InputSelect1 } from "../Components/Inputs/Select";
import { ErrorBar } from "../Components/ErrorBar";
import { set } from "lodash";
import { Help_CustomChart } from "../Dialogs/Help/Help_Inputs";
import { InputCheck } from "../Components/Inputs/Input_Check";
import { TopOffset } from "./Navbar_bs.jsx";

const ChartViewInput = ({ clientJson, show, onClose, showChart }) => {
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [doValidation, setDoValidation] = useState(0)



  const [avail, setAvail] = useState({
    charts: [],
    AccountNames: [],
    AccountTypes: [],
  });
  const [form, setForm] = useState({
    chart: "",
    AccountNames: [],
    AccountTypes: [],
    sweep: "",
    cost: false,
    byAccount: false,
    inout: false,
    cumulative: false,
    ignoreReturnType: false,
    sumAccountTypes: false,
  });

  const chartTypes = [
    "Account Bar and Value",
    "Multi Account Lines",
    "Tax Amounts",
    "Tax Rates",
  ];

  const getInputData = () => {
    var url = ScenarioUrl(clientJson, "chartinput", "");
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAvail({
            ...avail,
            AccountNames: json.Avail.AccountNames,
            AccountTypes: json.Avail.AccountTypes,
          });
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    slotProps: {
      paper: {
        sx: {
          maxHeight: ITEM_HEIGHT * 8.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    }
  };

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    }
    setForm(nf)
    return nf
  };

  const l_Change = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const Change_select = (e) => {
    let nf = onChange_any(e.target.name, e.target.value);
    validate(nf)
  };

  const c_Change = (e) => {
    console.log(e.target.checked);

    setForm({
      ...form,
      [e.target.name]: e.target.checked,
    });
  };

  const lm_Change = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;

    console.log(values);
    setForm({
      ...form,
      [e.target.name]: values,
    });
  };

  const nt_Change = (names, types) => {

    let n = typeof names === "string" ? names.split(",") : names;
    console.log(names);
    let t = typeof names === "string" ? types.split(",") : types;
    console.log(types);
    setForm({
      ...form,
      ["AccountNames"]: n,
      ["AccountTypes"]: t,
    });

  };


  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      getInputData();
    }
  }, [show]);

  const typesDisabled = () => {
    if (form.chart === chartTypes[0] ||
      form.chart === chartTypes[1]) {
      return false
    }
    return true
  };
  const accountsDisabled = () => {
    if (form.chart === chartTypes[2] || form.chart === chartTypes[3]) {
      return true;
    }
    return false;
  };
  const cumulativeDisabled = () => {
    if (form.chart === chartTypes[0]) {
      return false
    }
    // if (
    //   !(
    //     form.names.includes("RRSP") ||
    //     form.names.includes("TFSA") ||
    //     form.names.includes("Fees") ||
    //     form.types.includes("RRSP") ||
    //     form.types.includes("TFSA") ||
    //     form.types.includes("Fees")
    //   )
    // ) {
    //   return true;
    // }
    return true;
  };

  const costDisabled = () => {
    if (form.chart === chartTypes[0]) {
      return false
    }
    // if (
    //   !(
    //     form.names.includes("RRSP") ||
    //     form.names.includes("TFSA") ||
    //     form.names.includes("Fees") ||
    //     form.types.includes("RRSP") ||
    //     form.types.includes("TFSA") ||
    //     form.types.includes("Fees")
    //   )
    // ) {
    //   return true;
    // }
    return true;
  };

  const inoutDisabled = () => {
    if (form.chart === chartTypes[0]) {
      return false
    }
    // if (
    //   !(
    //     form.names.includes("RRSP") ||
    //     form.names.includes("TFSA") ||
    //     form.names.includes("Fees") ||
    //     form.types.includes("RRSP") ||
    //     form.types.includes("TFSA") ||
    //     form.types.includes("Fees")
    //   )
    // ) {
    //   return true;
    // }
    return true;
  };
  const byAccountDisabled = () => {
    if (form.chart === chartTypes[0]) {
      return false
    }
    // if (
    //   !(
    //     form.names.includes("RRSP") ||
    //     form.names.includes("TFSA") ||
    //     form.names.includes("Fees") ||
    //     form.types.includes("RRSP") ||
    //     form.types.includes("TFSA") ||
    //     form.types.includes("Fees")
    //   )
    // ) {
    //   return true;
    // }
    return true;
  };

  const ignoreReturnTypeDisabled = () => {
    if (form.chart === chartTypes[0]) {
      return false
    }
    return true;
  };
  const sumAccountTypesDisabled = () => {
    if (form.chart === chartTypes[0]) {
      return false
    }
    return true;
  };

  const addChart = () => { };

  const onSubmit = () => {
    setDoValidation(doValidation + 1)
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      let types =
        form.AccountTypes.length === 0 ? "" : "accountTypes=" + String(form.AccountTypes);
      let names =
        form.AccountNames.length === 0 ? "" : (types === "" ? "" : "&") + "accountNames=" + String(form.AccountNames);
      //let name0 = form.AccountTypes.length !== 0 ? "accountTypes=" + form.AccountTypes[0] : form.AccountNames.length === 0 ? "" : "account=" + form.AccountNames[0];
      let inout = form.inout ? "&inout=true" : ""
      let byAcct = form.byAccount ? "&byAcct=true" : ""
      let ignoreReturnType = form.ignoreReturnType ? "&ignoreReturnType=true" : ""
      let sumAccountTypes = form.sumAccountTypes ? "&sumAccountType=true" : ""
      let cumulative = form.cumulative ? "&cumulative=Cumulative" : ""
      let cost = form.cost ? "&cost=CostBasis" : ""

      let chart = "linechart";
      let arg = "";
      if (form.chart === chartTypes[0]) {
        chart = "chart";
        arg = "?" + types + names + byAcct + inout + ignoreReturnType + sumAccountTypes + cost + cumulative;
      } else if (form.chart === chartTypes[1]) {
        chart = "linechart";
        arg = "?" + types + "&" + names;
      } else if (form.chart === chartTypes[2]) {
        chart = "taxchart";
        arg = "";
      } else if (form.chart === chartTypes[3]) {
        chart = "taxratechart";
        arg = "";
      }

      let json = {
        uuid: empty_uuid,
        name: "Custom Chart",
        chart: chart,
        arg: arg,
      };
      showChart(json);
    }
  };

  const validate = (f) => {
    let ne = structuredClone(errors)
    let err = (f.chart === "") ? "Please select chart Type" : ""
    ne = set(ne, "chart", err)

    setErrors(ne)
  }

  useEffect(() => {
    validate(form)
  }, [doValidation])

  return (
    <Drawer anchor="right" open={show} onClose={onClose}>
      <Container maxWidth="true">
        <Stack sx={{ m: 4, mt: TopOffset }} spacing={2}>
          <Stack spacing={4}>
            <Box>
              <Button variant="contained" onClick={onSubmit}>
                Show Chart
              </Button>
            </Box>
            <InputSelect1
              label="Chart Type"
              name="chart"
              value={form.chart}
              onChange={Change_select}
              minWidth={320}
              maxWidth={320}
              errors={errors}
              avail={chartTypes}
            />
          </Stack>

          <InputAccountsTypesNames
            avail={avail}
            inputForm={form}
            onChange={nt_Change}
            accountsDisabled={accountsDisabled}
            typesDisabled={typesDisabled}
            MenuProps={MenuProps}
            both_allowed={true}
            onError={(e) => errorSet(errors, setErrors, "accounts", 0, e)}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="cost"
                disabled={costDisabled()}
                checked={form.cost}
                onChange={c_Change}
              />
            }
            label="Cost Basis"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="byAccount"
                disabled={byAccountDisabled()}
                checked={form.byAccount}
                onChange={c_Change}
              />
            }
            label="ByAccount"
          />

          <FormControlLabel
            control={
              <Checkbox
                name="inout"
                disabled={inoutDisabled()}
                checked={form.inout}
                onChange={c_Change}
              />
            }
            label="In/Out Transactions"
          /><FormControlLabel
            control={
              <Checkbox
                name="cumulative"
                disabled={cumulativeDisabled()}
                checked={form.cumulative}
                onChange={c_Change}
              />
            }
            label="Cumulative Contributions"
          />
          <InputCheck
            label="Aggregate Source Accounts to Types"
            name="sumAccountTypes"
            disabled={sumAccountTypesDisabled()}
            checked={form.sumAccountTypes}
            onChange={onChange_any}
          />
          <InputCheck
            label="Ignore Return Type"
            name="ignoreReturnType"
            disabled={ignoreReturnTypeDisabled()}
            checked={form.ignoreReturnType}
            onChange={onChange_any}
          />
          <Stack direction="row" spacing={2}>
            <Button variant="contained" disabled onClick={addChart}>
              Add Chart
            </Button>
          </Stack>

        </Stack>
        <Help_CustomChart />
        <ErrorBar error={errmsg} />
      </Container>
    </Drawer>
  );
};

export default ChartViewInput;
